import React, { Suspense, lazy } from 'react';
import { withRouter, Route, Switch } from 'react-router-dom';
import { Layout, Spin, Skeleton, Row, Modal } from 'antd';
import { connect } from "react-redux";
import { Footer, Header, DefaultLayout, MemberLayout } from '../../components';
import { isLoggedIn, getPermission, logout } from '../../utilities/services/AuthService';
import { setPermission } from '../../utilities/actions/PermissionAction';
import Error404 from '../../pages/error/Error404';
import Error403 from '../../pages/error/Error403';
import HomePage from '../../pages/home';
import LoginRouter from '../../routers/Login.router';
import MiniViewRouter from '../../routers/MiniView.router';
import CacheBuster from '../../CacheBuster';
import IdleTimer from 'react-idle-timer';
import axios from 'axios';

const ProfileComponent = lazy(() => import('../../pages/profile'));

const { Content } = Layout;
const router = [
    //hide menu Partner Management in v1.0.0
    //Partner Management and Voucher Management
    // { prefixname: "DSTRANGE", menucode: "DSTRANGE", layout: DefaultLayout, component: lazy(() => import('../../routers/DistanceRange.router')), path: "partner-management/distance-range" },
    // { prefixname: "EARMILES", menucode: "EARMILES", layout: DefaultLayout, component: lazy(() => import('../../routers/EarningMiles.router')), path: "partner-management/earning-miles" },
    // { prefixname: "BLACKOUT", menucode: "BLACKOUT", layout: DefaultLayout, component: lazy(() => import('../../routers/Blackout.router')), path: "partner-management/blackout" },
    { prefixname: "PARTNER", menucode: "PARTNER", layout: DefaultLayout, component: lazy(() => import('../../routers/Partner.router')), path: "partner-management/partner" },
    // { prefixname: "PEAKSEAS", menucode: "PEAKSEAS", layout: DefaultLayout, component: lazy(() => import('../../routers/PeakSeason.router')), path: "partner-management/peak-season" },
    // { prefixname: "AWRDTYPE", menucode: "AWRDTYPE", layout: DefaultLayout, component: lazy(() => import('../../routers/AwardType.router')), path: "partner-management/award-type" },
    // { prefixname: "AWARD", menucode: "AWARD", layout: DefaultLayout, component: lazy(() => import('../../routers/AwardList.router')), path: "partner-management/award-list" },
    // { prefixname: "PARTNGRP", menucode: "PARTNGRP", layout: DefaultLayout, component: lazy(() => import('../../routers/PartnerGroup.router')), path: "partner-management/partner-group" },
    // //Partner Profile
    // { prefixname: "DSTRANGE", menucode: "DSTRANGE", layout: DefaultLayout, component: lazy(() => import('../../routers/DistanceRangeProfile.router')), path: "partner-profile/distance-range" },
    // { prefixname: "EARMILES", menucode: "EARMILES", layout: DefaultLayout, component: lazy(() => import('../../routers/EarningMilesProfile.router')), path: "partner-profile/earning-miles" },
    // { prefixname: "BLACKOUT", menucode: "BLACKOUT", layout: DefaultLayout, component: lazy(() => import('../../routers/BlackoutProfile.router')), path: "partner-profile/blackout" },
    // { prefixname: "PARTNER", menucode: "PARTNER", layout: DefaultLayout, component: lazy(() => import('../../routers/PartnerProfile.router')), path: "partner-profile/partner" },
    // { prefixname: "PEAKSEAS", menucode: "PEAKSEAS", layout: DefaultLayout, component: lazy(() => import('../../routers/PeakSeasonProfile.router')), path: "partner-profile/peak-season" },
    // { prefixname: "AWRDTYPE", menucode: "AWRDTYPE", layout: DefaultLayout, component: lazy(() => import('../../routers/AwardTypeProfile.router')), path: "partner-profile/award-type" },
    // { prefixname: "AWARD", menucode: "AWARD", layout: DefaultLayout, component: lazy(() => import('../../routers/AwardListProfile.router')), path: "partner-profile/award-list" },
    // { prefixname: "PARTNGRP", menucode: "PARTNGRP", layout: DefaultLayout, component: lazy(() => import('../../routers/PartnerGroupProfile.router')), path: "partner-profile/partner-group" },

    //Voucher Management
    { prefixname: "PVCHRVRFY", menucode: "PVCHRVRFY", layout: DefaultLayout, component: lazy(() => import('../../routers/VoucherVerification.router')), path: "voucher-management/voucher-verification" },
    { prefixname: "PVCHRLST", menucode: "PVCHRLIST", layout: DefaultLayout, component: lazy(() => import('../../routers/VoucherList.router')), path: "voucher-management/voucher-list" },
    //File Management
    { prefixname: "PVCHRMGT", menucode: "PVCHRMGT", layout: DefaultLayout, component: lazy(() => import('../../routers/FileManagement.router')), path: "file-voucher" },
    { prefixname: "PENROLL", menucode: "PENROLLMENT", layout: DefaultLayout, component: lazy(() => import('../../routers/FileEnrollment.router')), path: "file-enrollment" },
    { prefixname: "PTERMINT", menucode: "PTERMINATE", layout: DefaultLayout, component: lazy(() => import('../../routers/FileTerminate.router')), path: "file-terminate" },
    { prefixname: "PAPPRVCO", menucode: "PAPPRVCOBRAND", layout: DefaultLayout, component: lazy(() => import('../../routers/FileApprovalCobrand.router')), path: "file-approval-cobrand" },
    { prefixname: "PTRANFRP", menucode: "PTRANSFERP", layout: DefaultLayout, component: lazy(() => import('../../routers/FileTransferPoint.router')), path: "file-transfer-point" },
    { prefixname: "PCBRNFST", menucode: "PCBRNDFST", layout: DefaultLayout, component: lazy(() => import('../../routers/FileCobrandFastTrack.router')), path: "file-cobrand-fast-track" },
    //Order Management
    { prefixname: "PPRNTORD", menucode: "PPRNTORDER", layout: DefaultLayout, component: lazy(() => import('../../routers/OrderList.router')), path: "order-management/printing" },
    { prefixname: "PPCKGORD", menucode: "PPCKGORDER", layout: DefaultLayout, component: lazy(() => import('../../routers/OrderListPackaging.router')), path: "order-management/package" },
    { prefixname: "PDLVYORD", menucode: "PDLVRYORDER", layout: DefaultLayout, component: lazy(() => import('../../routers/OrderListDelivery.router')), path: "order-management/delivery" },
    //Member
    { prefixname: "PMBRMGT", menucode: "PMBRMGT", layout: MemberLayout, component: lazy(() => import('../../routers/Member.router')), path: "member" },
];

class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            timeIdle: false, //seconds,
            isIdle: false
        }
        this.idleTimer = null;
        this.onIdle = this._onIdle.bind(this);
    }

    componentWillMount() {
        var pathname = this.props.location.pathname;
        var modulename = pathname.split("/")[1];

        if (isLoggedIn() && modulename !== 'activation' && modulename !== 'mini-view') {
            this.setState({ isLoading: true });

            let response = getPermission();
            /* USER MENU MAPPING */
            var usermenu_final = {};
            var menucode = '';
            var functioncode = '';
            var grant = null;
            var responseusermenu = (response && response.usermenu) ? response.usermenu : [];
            for (const group_key in responseusermenu) {
                for (const function_key in responseusermenu[group_key]['listmenu']) {
                    menucode = responseusermenu[group_key]['listmenu'][function_key]['menucode'];
                    if (usermenu_final[menucode] === undefined) { usermenu_final[menucode] = {}; }

                    for (const key in responseusermenu[group_key]['listmenu'][function_key]['function']) {
                        functioncode = responseusermenu[group_key]['listmenu'][function_key]['function'][key]['functioncode'];
                        grant = responseusermenu[group_key]['listmenu'][function_key]['function'][key]['grant'];
                        if (usermenu_final[menucode][functioncode] === undefined) { usermenu_final[menucode][functioncode] = null; }
                        usermenu_final[menucode][functioncode] = grant;
                    }
                }
            }

            /* MAPPING ENROLLMENT ACCESS */
            var enrollmentaccess = {};
            var membershipid = null;
            var responseenrollmembershiplist = (response && response.enrollmentaccess) ? response.enrollmentaccess : [];
            for (const key in responseenrollmembershiplist) {
                membershipid = responseenrollmembershiplist[key]['membershipid'];
                grant = responseenrollmembershiplist[key]['grant'];
                enrollmentaccess["MEMBERSHIP_" + membershipid] = grant;
            }
            this.props.setPermission({ usermenu_final, enrollmentaccess });
            this.setState({ isLoading: false });
        }

        /* get data timeIdle from env.json */
        axios.get("/config/env.json").then((response) => {
            const { data } = response;
            if (data) {
                const { timeIdle } = data;
                this.setState({ timeIdle });
            }
        });
    }

    _onIdle(e) {
        this.notificationForceLogout();
    }

    notificationForceLogout() {
        let secondsToGo = 5;
        const modal = Modal.warning({
            title: 'You are idle',
            content: `Your application will log out in ${secondsToGo} seconds.`,
            closable: false
        });
        const timer = setInterval(() => {
            secondsToGo -= 1;
            modal.update({
                content: `Your application will log out in ${secondsToGo} seconds.`,
            });
        }, 1000);

        setTimeout(() => {
            clearInterval(timer);
            modal.destroy();
            logout();
        }, secondsToGo * 1000);
    }

    render() {
        const { isLoading, timeIdle } = this.state;
        const { pathname } = this.props.location;
        const { modulename } = pathname.split("/")[1];

        let excludeRoute = ["activation", "announcement", "reset-password-member", "reset-password"];
        let isLoginSucceed = isLoggedIn() && !excludeRoute.includes(modulename);

        return (
            <CacheBuster {...this.props}>
                {({ loading, isLatestVersion, refreshCacheAndReload }) => {
                    if (loading) return null;

                    //check latest version application
                    if (!loading && !isLatestVersion) {
                        refreshCacheAndReload();
                    }

                    if (isLoginSucceed) {
                        return (
                            <Spin spinning={isLoading}>
                                {
                                    (timeIdle) ?
                                        <IdleTimer
                                            ref={ref => { this.idleTimer = ref }}
                                            element={document}
                                            onIdle={this.onIdle}
                                            debounce={250}
                                            timeout={1000 * timeIdle} /> : null
                                }
                                <Layout>
                                    <Header />
                                    <Content style={{ padding: '0 50px' }}>
                                        <Suspense fallback={
                                            <Row>
                                                <Content style={{ margin: '16px 0', padding: '24px', minHeight: 500, background: '#fff', boxShadow: '0 1px 15px 1px rgba(69,65,78,.1)' }}>
                                                    <Skeleton active />
                                                </Content>
                                            </Row>
                                        }>
                                            <Switch>
                                                <Route exact path='/' render={() => <DefaultLayout><HomePage /></DefaultLayout>} />
                                                <Route exact path='/profile' render={() => <DefaultLayout><ProfileComponent /></DefaultLayout>} />
                                                {
                                                    (!isLoading) ?
                                                        router.map((obj, key) => {
                                                            return (<PrivateRoute {...this.props} key={key} layout={obj.layout} component={obj.component} path={"/" + obj.path} permission={this.props.permission.usermenu} prefixname={obj.prefixname} menucode={obj.menucode} />)
                                                        }) : <Skeleton active />
                                                }
                                                <Route component={Error404} />
                                            </Switch>
                                        </Suspense>
                                    </Content>
                                </Layout>
                                <Footer />
                            </Spin>
                        )
                    } else {
                        return ((modulename === 'mini-view') ? <MiniViewRouter /> : <LoginRouter />);
                    }
                }}
            </CacheBuster>
        )
    }
}

function PrivateRoute({ layout: ManagementLayout, layout: DefaultLayout, component: Component, ...props }) {
    let permission = props.permission;
    let menucode = props.menucode;
    let access = props.prefixname + "_ACCESS";
    return (
        <Route {...props} permission={permission}
            render={props =>
                (permission[menucode] !== undefined) ?
                    (permission[menucode][access]) ?
                        (ManagementLayout) ? <ManagementLayout {...props}><Component {...props} permission={permission} /></ManagementLayout> : <Component {...props} permission={permission} />
                        : <Error403 {...props} /> : null} />);
}

const mapStateToProps = state => ({ ...state });
const mapDispatchToProps = dispatch => ({
    setPermission: (data) => dispatch(setPermission(data))
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));